<template>
	<div
		class="order-box insicht insicht--fade-up insicht--fast"
	>
		<div class="order-box__wrapper">
      <template v-if="maintenanceMode">
        <div
					class="order-box__content"
					:class="{
						'order-box__content--loading': loading || locationsLoading || isLoading,
					}"
				>
					<Loader
						class="order-box__loader"
						:show="(loading || locationsLoading) && !isLoading"
					/>
          <div
						class="order-box__content-wrapper order-box__content-wrapper--order"
						:class="{
							'order-box__content-wrapper--loading': loading || locationsLoading || isLoading,
						}"
					>
            <h2
              class="order-box__title"
              v-html="langValue('LANG_ORDER_BOX_TITLE') || ($te(`orderbox.title.${themeName}`) ? $t(`orderbox.title.${themeName}`) : $t(`orderbox.title.default`))"
            />
            <div
              class="order-box__input order-box__input--not-available"
            >
              <h3
                class="order-box__input-title"
                v-html="$t('orderbox.maintenance.title')"
              />
              <p
                class="order-box__input-text"
                v-html="$t('orderbox.maintenance.text')"
              />
            </div>
            <Button
              level="primary"
              :text="$t('orderbox.maintenance.reloadButton')"
              type="button"
              @click="reloadWidget"
            />
          </div>
        </div>
      </template>
			<template v-else-if="hasFeature('FEATURE_ORDERBOX_DELIVERY') || hasFeature('FEATURE_ORDERBOX_TAKEAWAY') || hasFeature('FEATURE_RESERVATION')">
				<div
					class="order-box__content"
					:class="{
						'order-box__content--loading': loading,
					}"
				>
					<Loader
						class="order-box__loader"
						:show="(loading || locationsLoading) && !isLoading"
					/>
					<div
						class="order-box__content-wrapper order-box__content-wrapper--order"
						:class="{
							'order-box__content-wrapper--loading': loading,
						}"
					>
						<template v-if="hasFeature('FEATURE_ORDERBOX_DELIVERY') || hasFeature('FEATURE_ORDERBOX_TAKEAWAY')">
							<h2
								v-if="isLoggedIn"
								class="order-box__title"
								v-sanitize="$t('orderbox.titleLoggedIn', { name: accountUserDetail.firstName })"
							/>
							<h2
								v-else
								class="order-box__title"
								v-html="langValue('LANG_ORDER_BOX_TITLE') || ($te(`orderbox.title.${themeName}`) ? $t(`orderbox.title.${themeName}`) : $t(`orderbox.title.default`))"
							/>
							<i18n
								path="orderbox.login"
								tag="div"
								class="order-box__login"
								v-if="hasFeature('FEATURE_ORDERBOX_LOGIN') && (hasFeature('FEATURE_ACCOUNT') || hasFeature('FEATURE_ACCOUNT_LOGGEDIN')) && !isLoggedIn"
							>
								<template #login>
									<a href="javascript:void(0)" @click="openLogin" class="order-box__login-link" v-html="$t('orderbox.loginLogin')"/>
								</template>
								<template #register>
									<a href="javascript:void(0)" @click="openRegister" class="order-box__login-link" v-html="$t('orderbox.loginRegister')"/>
								</template>
							</i18n>
							<template v-if="hasFeature('FEATURE_ORDERBOX_DELIVERY')">
								<div
									v-if="(deliveryLocations.length || (!deliveryLocations.length && locationsLoading)) && (!selectedShippingMethod || selectedShippingMethod == 'delivery')"
									class="order-box__input order-box__input--zip"
								>
									<div class="order-box__input-group">
										<FormInput
											class="order-box__input-element"
											name="order-box-zip"
											v-model.number="form.zip"
											@keydown="onZipKeydown"
											@input="onZipInput"
											:placeholder="$t('orderbox.deliveryLabel')"
											:label="$t('orderbox.deliveryLabel')"
											:minlength="4"
											:maxlength="4"
											inputmode="decimal"
											pattern="[0-9]{4}"
											:required="true"
											:error="false"
											ref="zipInput"
											:disabled="loading || isLoading || locationsLoading"
										/>
										<Button
											v-if="!selectedShippingMethod"
											class="order-box__input-button"
											@click.prevent="onDelivery"
											level="primary"
											type="button"
											:text="$t('orderbox.deliveryButton')"
											:disabled="loading || isLoading || locationsLoading"
										/>
									</div>
									<span
										class="order-box__input-error input-error"
										v-if="errors.zip"
										v-html="errors.zip"
									/>
								</div>
								<div
									v-else-if="!deliveryLocations.length && !locationsLoading"
									class="order-box__input order-box__input--not-available"
								>
									<h3
										class="order-box__input-title"
										v-html="$t('orderbox.deliveryTitle')"
									/>
									<p
										class="order-box__input-text"
										v-html="$t('orderbox.comingSoon')"
									/>
								</div>
							</template>

							<template v-if="hasFeature('FEATURE_ORDERBOX_TAKEAWAY')">
								<div
									v-if="(takeawayLocations.length || (!takeawayLocations.length && locationsLoading))  && (!selectedShippingMethod || selectedShippingMethod == 'takeaway')"
									class="order-box__input order-box__input--zip"
								>
									<div class="order-box__input-group">
										<FormInputSelect
											v-if="takeawayRegions.length > 1"
											class="order-box__input-element"
											v-model="form.selectedRegionCode"
											:options="takeawayRegionOptions"
											:label="$t('orderbox.takeawayRegionLabel')"
											@input="onTakeawayRegionSelect"
											ref="locationSelect"
											:disabled="loading || isLoading || locationsLoading"
										/>
										<FormInputSelect
											v-else
											class="order-box__input-element"
											v-model="form.selectedLocationCode"
											:options="takeawayLocationOptions"
											:label="$t('orderbox.takeawayLabel')"
											@input="onTakeawayLocationSelect"
											ref="locationSelect"
											:disabled="loading || isLoading || locationsLoading"
										/>
										<Button
											v-if="!selectedShippingMethod"
											class="order-box__input-button"
											@click.prevent="onTakeaway"
											level="primary"
											type="button"
											:text="$t('orderbox.takeawayButton')"
											:disabled="loading || isLoading || locationsLoading"
										/>
									</div>
									<span
										class="order-box__input-error input-error"
										v-if="errors.location"
										v-html="errors.location"
									/>
								</div>
								<div
									v-else-if="!takeawayLocations.length && !locationsLoading"
									class="order-box__input order-box__input--not-available"
								>
									<h3
										class="order-box__input-title"
										v-html="$t('orderbox.takeawayTitle')"
									/>
									<p
										class="order-box__input-text"
										v-html="$t('orderbox.comingSoon')"
									/>
								</div>
							</template>

							<div
								v-if="selectedShippingMethod && deliveryLocationMatches.length > 1 && !location"
								class="order-box__locations"
							>
								<Button
									@click.prevent="onCancel"
									class="order-box__locations-reset"
									level="tertiary"
									type="button"
									:text="$t('orderbox.changeType')"
									arrow
									reverse
								/>

								<h3
									class="order-box__locations-title"
									v-html="$t('orderbox.locations.deliveryTitle')"
								/>

								<OrderBoxLocation
									v-for="location in deliveryLocationMatches"
									:key="location.code"
									:location="formatLocation(location, selectedShippingMethod, null, form.zip)"
									:shipping-method="selectedShippingMethod"
									@click="onDeliveryLocationSelect($event, location.code)"
								/>
							</div>

							<div
								v-if="selectedShippingMethod && takeawayRegionLocations.length > 1 && !location"
								class="order-box__locations"
							>
								<Button
									@click.prevent="onCancel"
									class="order-box__locations-reset"
									level="tertiary"
									type="button"
									:text="$t('orderbox.changeType')"
									arrow
									reverse
								/>

								<h3
									v-if="hasFeature('FEATURE_ORDERBOX_GEOLOCATION') && form.selectedRegionCode == 'geolocation'"
									class="order-box__locations-title"
									v-html="$t('orderbox.locations.takeawayGeoTitle')"
								/>
								<h3
									v-else
									class="order-box__locations-title"
									v-html="$t('orderbox.locations.takeawayTitle', { region: $t(`orderbox.regions.${formatRegionCode(form.selectedRegionCode)}`)})"
								/>

								<OrderBoxLocation
									v-for="location in takeawayRegionLocations"
									:key="location.code"
									:location="formatLocation(location, selectedShippingMethod, form.selectedRegionCode)"
									:shipping-method="selectedShippingMethod"
									@click="onTakeawayLocationSelect($event, location.code)"
								/>

							</div>

							<template
								v-if="selectedShippingMethod && location"
							>
								<Button
									v-if="takeawayRegionLocations.length > 1 || deliveryLocationMatches.length > 1"
									@click.prevent="onResetLocation"
									class="order-box__locations-reset"
									level="tertiary"
									type="button"
									:text="$t('orderbox.locations.resetLocation')"
									arrow
									reverse
								/>
								<OrderBoxLocation
									:location="formatLocation(location, selectedShippingMethod, form.selectedRegionCode, form.zip)"
									:shipping-method="selectedShippingMethod"
									no-click
								/>

								<template v-if="locationClosedToday && showClosedMessage">
									<div class="order-box__closed">
										<h2
											class="order-box__closed-title"
											v-html="$t('orderbox.closedToday.title')"
										/>
										<div
											class="order-box__closed-text"
											v-html="$t('orderbox.closedToday.text', { location: location.name })"
										/>
										<div
											v-if="locationClosedTodayCoupon"
											class="order-box__closed-text"
											v-html="$t('orderbox.closedToday.couponText', { amount: formatDiscount(locationClosedTodayCoupon.discount) })"
										/>
										<div
											v-if="locationClosedTodayCoupon"
											class="order-box__closed-coupon"
										>
											<div class="order-box__closed-coupon-code">
												<div
													class="order-box__closed-coupon-label"
													v-html="$t('orderbox.closedToday.couponLabel')"
												/>
												<div
													class="order-box__closed-coupon-value"
													v-html="locationClosedTodayCoupon.code"
												/>
											</div>
											<Button
												class="order-box__closed-coupon-button"
												@click.prevent="onCopyToClipboard(locationClosedTodayCoupon.code)"
												level="primary"
												type="button"
												:text="copyCouponText || $t('orderbox.closedToday.couponCopy')"
												icon="duplicate"
												small
											/>
										</div>
									</div>
									<Button
										@click.prevent="onContinueClosed"
										level="primary"
										type="button"
										:text="$t('orderbox.closedToday.orderButton')"
										block
									/>
								</template>
								<template
									v-else
								>
									<GeneralMessage
										v-if="errors.time"
										:message="errors.time"
										type="error"
										@close="errors.time = ''"
									/>
									<template v-if="!errors.zip && !errors.location && !isLocationExternal">
										<OrderBoxTime
                      :uber-direct="locationOrderUberDirect"
											:order-now="locationOrderNow"
											:order-now-available="locationOrderNowAvailable"
											:date="selectedDate"
											:dateMin="locationOrderMinDate.format('L')"
											:dateMax="locationOrderMaxDate.format('L')"
											:isDateDisabled="isDateDisabled.bind(this)"
											:time="selectedTime"
											:times="locationOrderTimes"
											:buttonText="orderButtonText"
											:yielding-messages="yieldingMessages"
											@ordernowchanged="onLocationOrderNowChange"
											@datechanged="onLocationDateSelect"
											@timechanged="onLocationTimeSelect"
											@click="onOrder"
										/>

										<div
											v-if="hasFeature('FEATURE_GROUP_ORDERS') && locationHasGroupOrder"
											class="order-box__icon-button"
										>
											<SVGUsers class="order-box__icon-button-icon"/>
											<div class="order-box__icon-button-content">
												<Button
													class="order-box__icon-button-button"
													:text="$t('orderbox.groupOrder.button')"
													type="button"
													level="tertiary"
													arrow
													:disabled="!locationOrderTimes.length && (!locationOrderNow || !locationOrderNowAvailable)"
													@click="onGroupOrderOpen"
												/>
												<div
													v-if="$te('orderbox.groupOrder.hint')"
													class="order-box__icon-button-hint"
													v-html="$t('orderbox.groupOrder.hint')"
												/>
											</div>
										</div>
									</template>

									<div
										class="order-box__external"
										v-else-if="isLocationExternal"
									>
										<h4
											class="order-box__external-title"
											v-html="location.name"
										/>
										<p class="order-box__external-text" v-html="$t('orderbox.externalCourierText')"/>
										<Button
											v-if="locationExternalUrl"
											class="order-box__external-button"
											:href="locationExternalUrl"
											target="_blank"
											level="secondary"
											type="button"
											:text="$t('orderbox.externalCourierButton')"
											arrow
										/>
									</div>
								</template>
								<Button
									@click.prevent="onCancel"
									class="order-box__time-reset"
									level="tertiary"
									type="button"
									:text="$t('orderbox.changeType')"
									arrow
									reverse
								/>
							</template>
							<template
								v-else-if="selectedShippingMethod && !location && errors.zip"
							>
								<Button
									@click.prevent="onCancel"
									class="order-box__time-reset"
									level="tertiary"
									type="button"
									:text="$t('orderbox.changeType')"
									arrow
									reverse
								/>
							</template>
						</template>
						<!-- <template v-else>
							<div class="order-box__input order-box__input--not-available">
								<h3
									class="order-box__input-title"
									v-html="$t('orderbox.notAvailableTitle', {delivery: $t('orderbox.deliveryTitle'), takeaway: $t('orderbox.takeawayTitle')})"
								/>
								<p
									class="order-box__input-text"
									v-html="$t('orderbox.comingSoon')"
								/>
							</div>
						</template> -->
					</div>
					<template v-if="hasFeature('FEATURE_RESERVATION') && (locationsLoading || reservationLocations.length)">
						<div
							class="order-box__content-wrapper order-box__content-wrapper--reservation"
							:class="{
								'order-box__content-wrapper--loading': loading,
							}"
						>
							<h3
								class="order-box__subtitle"
								v-html="$t(`orderbox.reservationTitle`)"
							/>
							<div class="order-box__input-group">
								<FormInputSelect
									v-if="reservationRegions.length > 1"
									class="order-box__input-element"
									v-model="reservationForm.selectedRegionCode"
									:options="reservationRegionOptions"
									:label="$t('orderbox.reservationRegionLabel')"
									@input="onReservationRegionSelect"
									ref="locationSelect"
									:disabled="loading || isLoading || locationsLoading"
								/>
								<FormInputSelect
									v-else
									class="order-box__input-element"
									v-model="reservationForm.selectedLocationCode"
									:options="reservationLocationOptions"
									:label="$t('orderbox.reservationLabel')"
									@input="onReservationLocationSelect"
									ref="locationSelect"
									:disabled="loading || isLoading || locationsLoading"
								/>
								<Button
									v-if="!reservationForm.selectedRegionCode && !reservationForm.selectedLocationCode"
									class="order-box__input-button"
									@click.prevent="onReservation"
									level="primary"
									type="button"
									:text="$t('orderbox.reservationButton')"
									:disabled="loading || isLoading || locationsLoading"
								/>
							</div>
							<span
								class="order-box__input-error input-error"
								v-if="errors.reservation"
								v-html="errors.reservation"
							/>

							<div
								v-if="reservationRegionLocations.length > 1 && reservationForm.selectedRegionCode && !reservationForm.selectedLocationCode"
								class="order-box__locations"
							>
								<Button
									@click.prevent="onReservationCancel"
									class="order-box__locations-reset"
									level="tertiary"
									type="button"
									:text="$t('orderbox.cancelReservation')"
									arrow
									reverse
								/>

								<h3
									v-if="hasFeature('FEATURE_ORDERBOX_GEOLOCATION') && reservationForm.selectedRegionCode == 'geolocation'"
									class="order-box__locations-title"
									v-html="$t('orderbox.locations.takeawayGeoTitle')"
								/>
								<h3
									v-else
									class="order-box__locations-title"
									v-html="$t('orderbox.locations.takeawayTitle', { region: $t(`orderbox.regions.${formatRegionCode(reservationForm.selectedRegionCode)}`)})"
								/>

								<OrderBoxLocation
									v-for="location in reservationRegionLocations"
									:key="location.code"
									:location="formatLocation(location, 'takeaway', reservationForm.selectedRegionCode)"
									shipping-method="takeaway"
									@click="onReservationLocationSelect($event, location.code)"
								/>
							</div>
							<template
								v-if="reservationForm.selectedLocationCode"
							>
								<Button
									v-if="reservationRegionLocations.length > 1"
									@click.prevent="onResetReservationLocation"
									class="order-box__locations-reset"
									level="tertiary"
									type="button"
									:text="$t('orderbox.locations.resetLocation')"
									arrow
									reverse
								/>
								<OrderBoxLocation
									:location="formatLocation(reservationLocation, 'takeaway', reservationForm.selectedRegionCode)"
									shipping-method="takeaway"
									no-click
								/>
								<div class="order-box__time">
									<keep-alive>
										<Button
											class="order-box__time-button"
											@click.prevent="onReservationSubmit"
											level="primary"
											type="button"
											:text="$t('orderbox.reservationButton')"
										/>
									</keep-alive>
								</div>
								<Button
									@click.prevent="onReservationCancel"
									class="order-box__time-reset"
									level="tertiary"
									type="button"
									:text="$t('orderbox.cancelReservation')"
									arrow
									reverse
								/>
							</template>
						</div>
					</template>
          <div
            v-if="orderBoxLink"
						class="order-box__content-wrapper order-box__content-wrapper--links"
						:class="{
							'order-box__content-wrapper--loading': loading,
						}"
					>
            <h3
              v-if="orderBoxLink.title"
              class="order-box__subtitle"
              v-sanitize="orderBoxLink.title"
            />
            <div
              v-if="orderBoxLink.description"
              class="order-box__text"
              v-sanitize="orderBoxLink.description"
            />
            <Button
              :text="orderBoxLink.text"
              type="button"
              level="tertiary"
              arrow
              :href="orderBoxLink.url"
              :target="orderBoxLink.target"
            />
          </div>
				</div>
			</template>
		</div>
		<Modal
			v-if="hasFeature('FEATURE_GROUP_ORDERS')"
			ref="groupOrderModal"
			overlay-type="group-order"
			:html-classes="['hide--header', 'show--modal']"
			v-slot="{ closeModal }"
			narrow
		>
			<OverlayGroupOrderForm
				:title="$t('orderbox.groupOrder.title')"
				:button-text="groupOrderButtonText"
				:loading="loading || isLoading || locationsLoading"
				@cancel:grouporder="closeModal"
				@submit:grouporder="onGroupOrderSubmit"
			/>
		</Modal>
	</div>
</template>

<script>
import Vue from 'vue';
import {mapGetters} from 'vuex'
import { ValidationProvider, ValidationObserver } from "vee-validate"
import FormInput from '@/components/FormInput';
import FormInputSelect from '@/components/FormInputSelectCustom';
import Button from '@/components/Button';
import Modal from '@/components/Modal';
import Loader from '@/components/Loader';
import OrderBoxLocation from '@/components/OrderBoxLocation';
import OrderBoxTime from '@/components/OrderBoxTime';
import GeneralMessage from '@/components/GeneralMessage';
import OverlayGroupOrderForm from '@/pages/OverlayGroupOrderForm';
import leadingZero from '@/utils/leadingZero';
import {getUrlParams} from '@/utils/urlParams';
import htmlComponent from "htmlcomponent";
import { dayjs, isSameDay, dayjsLocal } from "@/helpers/dayjs"
import {eventhub, EVENT_CART_CREATED} from '@/store/eventhub';
import { toCamel } from '@/utils/convertcase';
import pushGTM from '@/utils/pushGTM'
import GenericMixin from '@/mixins/GenericVueMixin'

export default {
  mixins: [
    GenericMixin
  ],
	components: {
		ValidationProvider,
		ValidationObserver,
		FormInput,
		FormInputSelect,
		Button,
		Modal,
		Loader,
		OrderBoxTime,
		OrderBoxLocation,
		GeneralMessage,
		OverlayGroupOrderForm,
	},
	props: {
		locationCode: String,
	},
	data() {
		return {
			form: {
				zip: "",
				selectedLocationCode: null,
				selectedRegionCode: null,
			},
			reservationForm: {
				selectedLocationCode: null,
				selectedRegionCode: null,
			},
			groupOrderForm: {
				join: false,
				token: null,
				name: ''
			},
			errors: {
				zip: '',
				location: '',
				time: '',
				region: '',
				reservation: '',
			},
			edit: false,
			selectedShippingMethod: "",
			error: null,
			loading: false,
			referralToken: null,
			showClosedMessage: false,
			copyCouponText: null,
			copyCouponTextTimeout: null,
			geolocationAvailable: this.hasFeature('FEATURE_ORDERBOX_GEOLOCATION') && 'geolocation' in navigator,
			geolocation: null,
		};
	},
	computed: {
		...mapGetters("location", [
			"locationsLoading",
			"locations",
			"location",
			"locationRegions",
			"locationOrderZip",
			"locationOrderMinDate",
			"locationOrderMaxDate",
			"locationOrderDisabledDates",
			"locationOrderTimes",
			"locationOrderDate",
			"locationOrderTime",
      "locationOrderUberDirect",
			"locationOrderNow",
			"locationOrderNowAvailable",
			"locationYieldingMessages",
			"locationClosedToday",
			"locationClosedTodayCoupon",
		]),
		...mapGetters("cart", [
			"channelName",
			"shippingMethod"
		]),
		...mapGetters("account", [
			"isLoggedIn",
			"accountUserDetail",
		]),
		...mapGetters('loader', [
			'isLoading',
		]),
		...mapGetters([
			'maintenanceMode',
		]),
		deliveryLocations() {
			return this.locations
				.filter(
					channel => channel.location.delivery
					&& channel.zips.length
					&& (
						channel.location.delivery.openingHours.length
						|| channel.location.delivery.hasExternalUrl
						|| channel.zips.some(zip => zip.externalPartnerDeliveryEnabled)
					)
					&& (
						channel.location.delivery.hasDailyDelivery
						|| channel.location.delivery.todayClosed
					)
				)
		},
		deliveryLocationMatches() {
			return this.deliveryLocations.filter(channel => channel.zips.some(v => v.zip == this.form.zip))
		},
		takeawayLocations() {
			return this.locations
				.filter(
					channel => channel.location.takeaway
					&& channel.location.takeaway.openingHours.length
					&& (
						channel.location.takeaway.hasDailyTakeaway
						|| channel.location.takeaway.todayClosed
					)
				)
		},
		takeawayLocationOptions() {
			return this.takeawayLocations
				.map(location => {
					return {
						value: location.code,
						label: location.name
					}
				})
		},
		takeawayRegions() {
			return this.hasFeature('FEATURE_ORDERBOX_REGIONS')
				? this.locationRegions
					.reduce((regions, region) => {
						let locations = region.locations?.filter(location => this.takeawayLocations.find(l => l.code == location.code)) || [];
						if (locations.length) {
							regions.push({
								...region,
								locations
							});
						}
						return regions;
					}, [])
				: [];
		},
		takeawayRegionOptions() {
			return this.takeawayRegions
				.map(region => {
					return {
						value: region.code,
						label: this.$t(`orderbox.regions.${this.formatRegionCode(region.code)}`)
					}
				})
				.reduce((regions, region, index, array) => {
					if (this.hasFeature('FEATURE_ORDERBOX_GEOLOCATION') && index == 0 && this.geolocationAvailable) {
						regions.push({
							value: 'geolocation',
							label: `⌖ ${this.$t('orderbox.regions.geolocation')}`,
						})
					}
					regions.push(region);
					return regions;
				}, [])
		},
		takeawayRegionLocations() {
			if (
					this.hasFeature('FEATURE_ORDERBOX_GEOLOCATION')
					&& this.form.selectedRegionCode == 'geolocation'
					&& this.geolocationAvailable
					&& this.geolocation
			) {
				return this.takeawayLocations
					.filter(location => location.location.address.lat && location.location.address.long)
					.map(location => {
						const distance = this.calculateDistance(location, this.geolocation.coords);

						return {
							...location,
							distance,
						}
					})
					.sort((a, b) => {
						return a.distance - b.distance;
					})
					.filter(location => location.distance < 21)
			}
			return this.takeawayRegions.find(l => l.code == this.form.selectedRegionCode)?.locations || []
		},
		reservationLocation() {
			return this.reservationLocations.find(channel => channel.code == this.reservationForm.selectedLocationCode);
		},
		reservationLocations() {
			return this.locations.filter(channel => channel.location.hasReservation && !channel.alternativeBrand)
		},
		reservationLocationOptions() {
			return this.reservationLocations
				.map(location => {
					return {
						value: location.code,
						label: location.name
					}
				})
		},
		reservationRegions() {
			return this.hasFeature('FEATURE_ORDERBOX_REGIONS')
				? this.locationRegions
					.reduce((regions, region) => {
						let locations = region.locations?.filter(location => this.reservationLocations.find(l => l.code == location.code)) || [];
						if (locations.length) {
							regions.push({
								...region,
								locations
							});
						}
						return regions;
					}, [])
				: [];
		},
		reservationRegionOptions() {
			return this.reservationRegions
				.map(region => {
					return {
						value: region.code,
						label: this.$t(`orderbox.regions.${this.formatRegionCode(region.code)}`)
					}
				})
				.reduce((regions, region, index, array) => {
					if (this.hasFeature('FEATURE_ORDERBOX_GEOLOCATION') && index == 0 && this.geolocationAvailable) {
						regions.push({
							value: 'geolocation',
							label: `⌖ ${this.$t('orderbox.regions.geolocation')}`,
						})
					}
					regions.push(region);
					return regions;
				}, [])
		},
		reservationRegionLocations() {
			if (
					this.hasFeature('FEATURE_ORDERBOX_GEOLOCATION')
					&& this.reservationForm.selectedRegionCode == 'geolocation'
					&& this.geolocationAvailable
					&& this.geolocation
			) {
				return this.reservationLocations
					.filter(location => location.location.address.lat && location.location.address.long)
					.map(location => {
						const distance = this.calculateDistance(location, this.geolocation.coords);

						return {
							...location,
							distance,
						}
					})
					.sort((a, b) => {
						return a.distance - b.distance;
					})
					.filter(location => location.distance < 21)
			}
			return this.reservationRegions.find(l => l.code == this.reservationForm.selectedRegionCode)?.locations || []
		},
		orderButtonText() {
			return this.selectedShippingMethod === 'delivery' ? this.$t('orderbox.deliveryButton') : this.$t('orderbox.takeawayButton');
		},
		selectedDate: {
			get () {
				return this.locationOrderDate
			},
			set (value) {
				this.$store.dispatch('location/setOrderDate', { dateStr: value })
			}
		},
		selectedTime: {
			get () {
				return this.locationOrderTime
			},
			set (value) {
				this.$store.dispatch('location/setOrderTime', { timeStr: value })
			}
		},
		isLocationExternal() {
			return this.selectedShippingMethod == 'delivery' && ((this.location && this.location.location.delivery.hasExternalUrl) || (this.locationOrderZip && this.locationOrderZip.externalPartnerDeliveryEnabled));
		},
		locationExternalUrl() {
			return this.locationOrderZip && this.locationOrderZip.externalPartnerDeliveryEnabled && this.locationOrderZip.externalUrl
				? this.locationOrderZip.externalUrl
				: this.location && this.location.location.delivery.hasExternalUrl
					? this.location.location.delivery.externalUrl
					: '';
		},
		yieldingMessages() {
			return this.locationYieldingMessages
				.filter(m => !m.type || m.type == this.selectedShippingMethod)
				.map(m => m.content)
		},
		groupOrderButtonText() {
			return this.groupOrderForm.join ? this.$t('orderbox.groupOrder.joinButton') : this.$t('orderbox.groupOrder.orderButton')
		},
		locationHasGroupOrder() {
			return !!this.location?.location?.hasGroupOrder
		},
    orderBoxLink() {
      return this.themeValue('THEME_ORDER_BOX_LINK')
    }
	},
	watch: {
		locations: function(value) {
			if (value.length) {
				this.readUrlParams()
				this.selectDefaultReservationLocation()
			}
		},
		locationCode(value) {
			if (value) {
				this.readUrlParams();
			}
		},
		location(value) {
			this.showClosedMessage = this.locationClosedToday;
		}
	},
	methods: {
		selectDefaultReservationLocation() {
			if (
				!this.hasFeature('FEATURE_ORDERBOX_DELIVERY')
				&& !this.hasFeature('FEATURE_ORDERBOX_TAKEAWAY')
				&& this.reservationLocations.length === 1
				&& this.reservationRegions.length <= 1
				&& !this.reservationForm.selectedLocationCode
			) {
				this.onReservationLocationSelect(null, this.reservationLocations[0].code)
			}
		},
		openLogin() {
			htmlComponent.send('overlay:open', {type: 'login'});
		},
		openRegister() {
			htmlComponent.send('overlay:open', {type: 'login', tab: 'register'});
		},
		onIndining() {
			if (this.hasFeature('FEATURE_RESERVATION')) {
				this.$store.dispatch('redirect', { name: 'indining' })
			}
		},
		onReservation() {
			if (this.hasFeature('FEATURE_RESERVATION')) {
				this.$store.dispatch('redirect', { name: 'reservation' })
			}
		},
		onContinueClosed() {
			this.showClosedMessage = false;
		},
		async onCopyToClipboard(value) {
			try {
				await navigator.clipboard.writeText(value);
				this.copyCouponText = this.$t('orderbox.closedToday.couponCopied');
				clearTimeout(this.copyCouponTextTimeout);
				this.copyCouponTextTimeout = setTimeout(() => {
					this.copyCouponText = this.$t('orderbox.closedToday.couponCopy');
				}, 2000);
			}
			catch(err) {
				this.isDebug() && console.error(err);
			}
		},
		onResetLocation() {
			this.errors.zip = '';
			this.errors.location = '';
			this.errors.time = '';
			this.errors.region = '';
			this.form.selectedLocationCode = '';
			this.showClosedMessage = false;
			this.$store.dispatch('location/clearLocation')
		},
		onCancel(e) {
			this.loading = false;
			this.errors.zip = '';
			this.errors.location = '';
			this.errors.time = '';
			this.errors.region = '';
			this.form.zip = '';
			this.form.selectedLocationCode = '';
			this.form.selectedRegionCode = '';
			this.selectedShippingMethod = '';
			this.showClosedMessage = false;
			this.$store.dispatch('location/clearLocation')
		},
		onResetReservationLocation() {
			this.reservationForm.selectedLocationCode = '';
		},
		onReservationCancel(e) {
			this.loading = false;
			this.reservationForm.selectedLocationCode = '';
			this.reservationForm.selectedRegionCode = '';
		},
		onZipKeydown(e) {
			if (!e.metaKey && !e.ctrlKey && e.key && e.key.length <= 1 && !/[0-9]/.test(e.key)) {
				e.preventDefault()
			}
			this.error = null;
		},
		onZipInput(value) {
			if (/[^\d]/.test(value)) {
				Vue.set(this.form, 'zip', value.replace(/[^\d]/ig,''));
				this.$refs.zipInput.$refs.input.value = this.form.zip;
			}
			const zip = this.form.zip
			if (zip && zip.toString().length == 4) {
				this.errors.zip = '';

        pushGTM({
          event: 'zipcode',
          brand: this.brand,
          plz: zip,
        });

				if (this.deliveryLocationMatches.length == 1) {
					const location = this.deliveryLocationMatches[0];
					const currentZip = location.zips.find(v => v.zip == zip);

					this.selectedShippingMethod = 'delivery';

					this.$store.dispatch('location/setLocation', { location, deliveryMethod: this.selectedShippingMethod, zip: currentZip, deliveryTime: currentZip.deliveryTime })
					this.updateDateTime();
					return
				}
				else if (this.deliveryLocationMatches.length > 1) {
					this.selectedShippingMethod = 'delivery';
				}
				else {
					this.errors.zip = this.$t('orderbox.errorZip')
				}
			}

			else {
				if (this.selectedShippingMethod == 'delivery') {
					this.errors.zip = this.$t('orderbox.errorZipInvalid')
				}
			}

			this.$store.dispatch('location/clearLocation')
		},
		onDeliveryLocationSelect(e, code) {
			if (code) {
				this.form.selectedLocationCode = code;
			}

			const location = this.deliveryLocationMatches.find(v => v.code == this.form.selectedLocationCode)
			const currentZip = location.zips.find(v => v.zip == this.form.zip);

			this.selectedShippingMethod = 'delivery';
			this.errors.zip = '';
			this.errors.location = '';

			this.$store.dispatch('location/setLocation', { location, deliveryMethod: this.selectedShippingMethod, zip: currentZip, deliveryTime: currentZip.deliveryTime })
			this.updateDateTime();

			this.$nextTick(() => {
				this.$el.scrollIntoView()
			});
		},
		onTakeawayLocationSelect(e, code) {
			if (code) {
				this.form.selectedLocationCode = code;
			}
			const location = this.takeawayLocations.find(v => v.code == this.form.selectedLocationCode)
			this.form.zip = '';
			this.selectedShippingMethod = 'takeaway';
			this.errors.location = '';

			if (location) {
				this.$store.dispatch('location/setLocation', { location, deliveryMethod: this.selectedShippingMethod, deliveryTime: location.location.takeaway.deliveryTime })
				this.updateDateTime();
			}

			this.$nextTick(() => {
				this.$el.scrollIntoView()
			});
		},
		onTakeawayRegionSelect(e, code) {
			this.loading = true;

			if (code) {
				this.form.selectedRegionCode = code;
			}
			this.form.zip = '';
			this.selectedShippingMethod = 'takeaway';
			this.errors.location = '';
			this.errors.region = '';

			this.form.selectedLocationCode = '';
			this.$store.dispatch('location/clearLocation')

			if (this.hasFeature('FEATURE_ORDERBOX_GEOLOCATION') && this.form.selectedRegionCode == 'geolocation') {
				this.geolocationRequest();
			}
			else {
				this.loading = false;
				if (this.takeawayRegionLocations.length == 1) {
					this.onTakeawayLocationSelect(null, this.takeawayRegionLocations[0].code);
				}

			}
		},
		onReservationLocationSelect(e, code) {
			if (code) {
				this.reservationForm.selectedLocationCode = code;
			}
			const location = this.reservationLocations.find(v => v.code == this.reservationForm.selectedLocationCode)

			this.$nextTick(() => {
				this.$el.scrollIntoView()
			});
		},
		onReservationRegionSelect(e, code) {
			this.loading = true;

			if (code) {
				this.reservationForm.selectedRegionCode = code;
			}

			this.reservationForm.selectedLocationCode = '';

			if (this.hasFeature('FEATURE_ORDERBOX_GEOLOCATION') && this.reservationForm.selectedRegionCode == 'geolocation') {
				this.reservationGeolocationRequest();
			}
			else {
				this.loading = false;
				if (this.reservationRegionLocations.length == 1) {
					this.onReservationLocationSelect(null, this.reservationRegionLocations[0].code);
				}
			}
		},
		geolocationRequest() {
			this.loading = true;
			this.errors.location = '';
			navigator.geolocation.getCurrentPosition(this.geolocationSuccess.bind(this), this.geolocationError.bind(this), {
				enableHighAccuracy: true,
				// timeout: 5000,
				// maximumAge: 0
			});
		},
		geolocationSuccess(position) {
			this.geolocation = position;
			this.loading = false;
			if (this.takeawayRegionLocations.length == 1) {
				this.onTakeawayLocationSelect(null, this.takeawayRegionLocations[0].code);
			}
			else if (!this.takeawayRegionLocations.length) {
				this.errors.location = this.$t('orderbox.locations.takeawayGeoEmpty');
			}
		},
		geolocationError() {
			this.selectedShippingMethod = '';
			this.form.selectedRegionCode = '';
			this.geolocationAvailable = false;
			this.loading = false;
		},
		reservationGeolocationRequest() {
			this.loading = true;
			this.errors.reservation = '';
			navigator.geolocation.getCurrentPosition(this.reservationGeolocationSuccess.bind(this), this.reservationGeolocationError.bind(this), {
				enableHighAccuracy: true,
				// timeout: 5000,
				// maximumAge: 0
			});
		},
		reservationGeolocationSuccess(position) {
			this.geolocation = position;
			this.loading = false;
			if (this.reservationRegionLocations.length == 1) {
				this.onReservationLocationSelect(null, this.reservationRegionLocations[0].code);
			}
			else if (!this.reservationRegionLocations.length) {
				this.errors.reservation = this.$t('orderbox.locations.takeawayGeoEmpty');
			}
		},
		reservationGeolocationError() {
			this.reservationForm.selectedRegionCode = '';
			this.geolocationAvailable = false;
			this.loading = false;
		},
		calculateDistance(location, {latitude, longitude} = {}) {
			const radlat1 = Math.PI * latitude / 180;
			const radlat2 = Math.PI * location.location.address.lat / 180;
			const theta = longitude - location.location.address.long;
			const radtheta = Math.PI * theta  /  180;
			let distance = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
			distance = Math.acos(distance);
			distance = distance * 180 / Math.PI;
			distance = distance * 60 * 1.1515;
			distance = distance * 1.609344;
			return distance;
		},
		updateDateTime() {
			this.selectedDate = this.locationOrderMinDate.format('L');
			this.selectedTime = this.locationOrderTimes[0]?.value;
		},
		queryZipForLocation(zip) {
			return this.deliveryLocations.find(
				channel => channel.location.delivery != null
					&& channel.zips.find(v => v.zip == zip)
			)
		},
		onLocationOrderNowChange(value) {
			this.$store.dispatch('location/setOrderNow', { value })
		},
		onLocationDateSelect(date) {
			this.selectedDate = date;

			if (this.selectedDate) {
				this.selectedTime = this.locationOrderTimes[0]?.value;
			}
		},
		onLocationTimeSelect(time) {
			this.selectedTime = time;
		},
		onDelivery(e) {
			this.selectedShippingMethod = 'delivery';

			if (this.form.zip.toString().length < 4) {
				this.errors.zip = this.$t('orderbox.errorZipInvalid')
				this.$refs.zipInput.focus();
			}
		},
		onTakeaway(e) {
			this.selectedShippingMethod = 'takeaway';

			if (!this.form.selectedLocationCode) {
				this.errors.location = this.$t('orderbox.errorLocation')
			}
		},
		onReservation(e) {
			if (!this.reservationForm.selectedLocationCode) {
				this.errors.reservation = this.$t('orderbox.errorLocation')
			}
		},
		onReservationSubmit() {
			if (!this.reservationForm.selectedLocationCode) {
				this.errors.reservation = this.$t('orderbox.errorLocation')
				return
			}

			this.$store.dispatch('redirect', {
				name: 'reservation-restaurant',
				params: {
					code: this.reservationForm.selectedLocationCode
				}
			})
		},

		async onOrder({ noRedirect = false } = {}) {
			let validDateTime = (this.locationOrderNow && this.locationOrderNowAvailable) || (this.selectedDate && this.selectedTime)
			if (this.selectedShippingMethod && this.location && validDateTime) {
				const zip = this.selectedShippingMethod == 'delivery' ? parseInt(this.form.zip) : 0
				this.loading = true
				this.errors.time = '';
				try {
					return await this.$store.dispatch('openCartAtChannel', {
						channel: this.location.code,
						orderNow: this.locationOrderNow && this.locationOrderNowAvailable,
						deliverDate: this.selectedDate,
						deliverTime: this.selectedTime,
						zip,
						shippingCode: this.selectedShippingMethod,
						replaceOldCart: true,
						referralToken: this.referralToken,
						alternativeBrand: this.location.alternativeBrand,
						noRedirect
					})
					// we should get redirected, so non of this code does matter below here
				} catch (err) {
          this.isDebug() && console.error(err)
					// TODO: handle a possible error here
          if (err.isMaintenanceError) {
            this.onMaintenanceMode({ callback: this.onOrder, retry: true})
          }	else if (err?.response?.data?.message || err?.response?.data?.errors) {
            this.errors.time = err.response.data.errors && Object.values(err.response.data.errors).length
							? Array.from(new Set(Object.values(err.response.data.errors).flat())).join()
							: err.response.data.message ?? this.$t('forms.errors.generic')
					} else {
						throw err
					}
					this.loading = false
				}

			} else if (!validDateTime) {
				this.errors.time = this.$t('orderbox.errorTime')
			}

			return false
		},

		onGroupOrderOpen() {
			this.$refs.groupOrderModal.open();
		},
		async onGroupOrderSubmit({name}) {
			this.loading = true
			if (name) {
				this.groupOrderForm.name = name;
				this.$refs.groupOrderModal.close();
				if (!this.groupOrderForm.token) {
					try {
						this.groupOrderForm.token = await this.onOrder({ noRedirect: true })
					}
					catch(err) {
						// no need to anything, keep modal closed
					}
				}
				if (this.groupOrderForm.token) {
					try {
						await this.$store.dispatch('grouporder/addParticipant', { ...this.groupOrderForm })
						await this.$store.dispatch('redirect', {
							name: this.groupOrderForm.join ? 'shop-token' : 'shop',
							params: {
								basketToken: this.groupOrderForm.token
							}
						});
					}
					catch(err) {
						this.$refs.groupOrderModal.open();
					}
				}
			}
			this.loading = false
		},
		isDateDisabled(date) {
			const dates = this.locationOrderDisabledDates
			const check = dayjsLocal(date)
			return dates.find(d => isSameDay(d, check))
		},

		gotoStore() {
			this.$store.dispatch('redirect', {name: 'shop'})
		},
		editStore() {
			this.edit = true
		},
		readUrlParams() {
			const params = getUrlParams()

			const locations = this.deliveryLocations.filter(channel => channel.zips.some(v => v.zip == params.delivery))
			if (params.delivery && !this.selectedShippingMethod && locations.length) {
				this.form.zip = params.delivery
				this.onZipInput(params.delivery)
			}

			const locationCode = this.locationCode || params.takeaway
			if (locationCode) {
				const location = this.takeawayLocations.find(location => location.code == locationCode)
				if (!this.selectedShippingMethod && location) {
					if (this.hasFeature('FEATURE_ORDERBOX_REGIONS') && this.takeawayRegions.length > 1) {
						this.onTakeawayRegionSelect(null, location.location?.region || 'none')
					}
					this.onTakeawayLocationSelect(null, location.code)
				}
			}

			this.referralToken = params.referralToken || params['referral-token'] || params['referral'] || null

			if (params.joinOrder) {
				// TODO: find a way to make sure someone doesn't get added twice or that the owner doesn't get added as normal user
				this.groupOrderForm.token = params.joinOrder
				this.groupOrderForm.join = true
				this.$refs.groupOrderModal.open()
			}
		},
		formatDiscount(discount) {
			discount = '' + discount;
			if (discount.indexOf('%') < 0) {
				// multiply by 100 because coupon is in francs rather than cents
				discount = this.$options.filters.fwgpricecent(discount * 100, 'html')
			}
			return discount;
		},
		formatDistance(distance) {
			let formatted;
			if (distance < 1) {
				formatted = `${Math.max(Math.round(distance * 1000), 1)}m`;
			}
			else {
				formatted = `${Math.round(distance * 10) / 10}km`;
			}
			return this.$t('locations.distance', { distance: formatted });
		},
		formatLocation(location, shippingMethod, regionCode, zipCode) {
			let formatted = {
				image: location.image,
				name: location.name,
				code: location.code,
				brand: location.location.brand,
				region: location.location.region,
				address: location.location.address,
				distance: location.distance ? this.formatDistance(location.distance) : null,
				tags: location.location.tags ?? [],
			};

			if (shippingMethod === 'takeaway') {
				formatted = {
					...formatted,
					deliveryTime: location.location.takeaway.deliveryTime,
					minDeliveryAmount: location.location.takeaway.minDeliveryAmount,
				};
			}
			else if (zipCode) {
				const zip = location.zips.find(zip => zip.zip == zipCode)
				if (zip) {
					formatted = {
						...formatted,
						deliveryTime: zip.deliveryTime,
						deliveryPrice: zip.deliveryPrice,
						minDeliveryAmount: zip.minDeliveryAmount,
            uberDirect: this.locationOrderUberDirect,
					};
				}
			}

			if (
				this.hasFeature('FEATURE_ORDERBOX_GEOLOCATION')
				&& regionCode == 'geolocation'
				&& this.geolocationAvailable
				&& this.geolocation
				&& location.location.address.lat
				&& location.location.address.long
				&& !location.distance
			) {
				formatted.distance = this.formatDistance(this.calculateDistance(location, this.geolocation.coords));
			}

			return formatted;
		},
		formatRegionCode(code) {
			return toCamel(code);
		},
    async reloadWidget() {
      await this.$store.dispatch('initializeOrderbox')
    }
	},
	mounted() {
		this.readUrlParams();
		this.selectDefaultReservationLocation();
		eventhub.$on(EVENT_CART_CREATED, this.onCancel)
	},
	destroyed() {
		eventhub.$off(EVENT_CART_CREATED, this.onCancel)
	}
}
</script>

<style>

</style>
